import { createProject, editProject, delProject, closeProject, openProject, chooseProject } from '@/services/orgRealback'
import { getAdminId } from '@/services/organization'

export default {
  namespaced: true,
  state: {
    submitting: false,
    realbackAdminListDatas: []
  },
  mutations: {
    setRealbackAdminListDatas (state, datas) {
      state.realbackAdminListDatas = datas
    }
  },
  actions: {
    // 创建项目时，获取精准回传管理员id
    async getRealbackAdminId ({ commit }, params) {
      const chain = await getAdminId()
      chain
        .params(params)
        .onSuccess((raw) => {
          commit('setRealbackAdminListDatas', raw.list)
        })
        .config({ tip: false })
        .fetch()
      return chain
    },
    // 创建/修改项目
    async ajaxEditPro ({ commit, dispatch }, params) {
      commit('setSubmitting', true)
      let chain
      if (params.projectid) {
        chain = await editProject()
      } else {
        chain = await createProject()
      }

      chain
        .params(params)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .fetch()
      return chain
    },
    // 关闭项目
    async ajaxCloseProRealback ({ commit, dispatch, state }, params) {
      commit('setSubmitting', true)
      const chain = await closeProject()
      chain
        .params(params)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .fetch()
      return chain
    },
    // 重新打开项目
    async ajaxOpenProRealback ({ commit, dispatch }, params) {
      commit('setSubmitting', true)
      const chain = await openProject()
      chain
        .params(params)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .fetch()
      return chain
    },
    // 删除项目
    async ajaxDelProRealback ({ commit, dispatch }, params) {
      commit('setSubmitting', true)
      const chain = await delProject()
      chain
        .params(params)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .fetch()
      return chain
    },
    // 选择项目进入
    async chooseProject ({ commit, dispatch }, params) {
      const chain = await chooseProject()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
